import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import { Typography } from '@material-ui/core'
import { processEnv } from 'components/configuration/environmentVariables'
import React, { FC, useMemo } from 'react'
import useStyles from './ProductHistoryModal.styles'

type ProductInfoHeaderProps = {
    productName?: string
    sectionName?: string
    productType?: string
    firmDisplayName?: string
    listingId?: string
}

const ProductInfoHeader: FC<ProductInfoHeaderProps> = ({
    productName,
    sectionName,
    productType,
    firmDisplayName,
    listingId,
    ...rest
}) => {
    const classes = useStyles()

    const productListingHref = useMemo(() => {
        if (!Number(processEnv.REACT_APP_ShowUpdatedProductListings)) {
            return `/bpm/product-card-management/product/listing/${listingId}?showBackButton=false`
        }
        return `/bpm/products/product/listing/${listingId}?showBackButton=false`
    }, [processEnv])

    return (
        <GridContainer>
            <Typography
                data-testid="productInfoHeader"
                component="div"
                className={classes.productDetailsWrapper}
            >
                <a
                    href={productListingHref}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Typography className={classes.productName} component="div">
                        {!!productName ? productName : 'No product name'}
                    </Typography>
                </a>
                <Typography className={classes.productDetails} component="div">
                    {sectionName}
                </Typography>
                <Typography className={classes.productDetails} component="div">
                    {productType}
                </Typography>
                <Typography className={classes.productDetails} component="div">
                    {firmDisplayName}
                </Typography>
            </Typography>
        </GridContainer>
    )
}

export default ProductInfoHeader
